'use strict';

module.exports = /([{}])\1|\{([^}]*)\}|(%)%|(%(\w*))/g;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/var/STRING_FORMAT_REG.js
// module id = 152
// module chunks = 1